<template>
  <div class="contract-edit-contain" ref="contractContain">
    <p class="contract-edit-title">
      <span class="el-icon-caret-right"></span>{{ $t('user.essentialInformation') }}
    </p>
    <el-form
      class="contract-edit-form"
      label-position="top"
      ref="editForm"
      :model="contractData"
      :rules="editRule"
    >
      <el-form-item :label="$t('contract.supplierCode')" class="contract-form-li" prop="supplierOrgCode">
        <span slot="label">
          {{ $t('contract.supplierCode') }}
          <el-tooltip class="item"
                  :content="$t('contract.supplierCodeInfo')"
                   placement="right">
            <em class="el-icon-question" style="color:#409eff;font-style:normal;margin-left:5px"></em>
          </el-tooltip>
        </span>
        <el-select
          v-model="contractData.supplierOrgCode"
          filterable
          remote
          reserve-keyword
          :placeholder="$t('contract.teamNoOrCode')"
          :remote-method="remoteMethod"
          @change="choseSupplier"
          :disabled="isEdit==0&&releatedEdit"
          :loading="loading">
          <el-option
            v-for="(item,index) in options"
            :key="'contract'+index"
            :label="item.orgCode +'-'+item.nameCn"
            :value="item.orgCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('contract.idInfo')" class="contract-form-li" prop="contractNo">
        <el-input
          v-model="contractData.contractNo"
          :disabled="isEdit==0"
          maxlength="20"
          :placeholder="$t('contract.inputTips')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('contract.supplierId')" class="contract-form-li" prop="venderNo">
        <el-input
          v-model="contractData.venderNo"
          :disabled="true"
          :placeholder="$t('contract.inputTips')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('contract.companyCn')" class="contract-form-li" prop="supplierNameCn">
        <el-input
          v-model="contractData.supplierNameCn"
          :disabled="true"
          :placeholder="$t('contract.inputTips')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('contract.companyEn')" class="contract-form-li" prop="supplierNameEn">
        <el-input
          v-model="contractData.supplierNameEn"
          :disabled="true"
          :placeholder="$t('contract.inputTips')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('contract.validTime')" class="contract-form-li" prop="beginTime">
        <el-date-picker
          v-model="contractData.beginTime"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :editable="false"
          :clearable="true"
          :pickerOptions="pickerOptions2"
          :disabled="isEdit==0&&releatedEdit"
          :placeholder="$t('user.checkdate')">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('contract.novalidTime')" class="contract-form-li" prop="endTime">
        <el-date-picker
          v-model="contractData.endTime"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :editable="false"
          :clearable="true"
          :pickerOptions="pickerOptions"
          :placeholder="$t('user.checkdate')">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('contract.status')" class="contract-form-li" prop="status">
        <el-select v-model="contractData.status" :disabled="isEdit==0&&releatedEdit&&isEffect">
          <el-option
            v-for="(item,index) in statusList"
            :key="'status'+index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('contract.team')" class="contract-form-li" prop="ownOrgId">
        <el-select v-model="contractData.ownOrgId" :disabled="isEdit==0&&releatedEdit">
          <el-option
            v-for="item in teamList"
            :key="'team'+item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('contract.type')" class="contract-form-li" prop="type">
        <el-select v-model="contractData.type" @change="changeGetCostList" :disabled="isEdit==0">
          <el-option
            v-for="item in typeList"
            :key="'type'+item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <p class="contract-edit-title contract-edit-title2" v-if="contractData.type">{{ $t('contract.newCost') }}</p>
      <div class="contract-cost-add clearfix" v-if="contractData.type">
        <el-select class="contract-cost-add-select" v-model="costType" :placeholder="$t('contract.costPlaceHolder')">
          <el-option
            v-for="(item,index) in costList"
            :key="'costType'+index"
            :label="item.name"
            :value="item.code"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
         <el-button class="edit-button" type="primary" @click="addCost">
          {{ $t("add") }}
        </el-button>
      </div>
      <!-- 费用 -->
      <div class="contract-type-module" v-for="(i,k) in moduleList" :key="'module'+k">
        <p class="contract-type-module-title" >{{ i.dictName }}
          <el-tooltip placement="top-start" effect="light" v-if="i.dictValue==='1'">
            <div slot="content">{{ $t("contract.trainerInfo") }}</div>
            <em class="el-icon-question contract-type-question"></em>
          </el-tooltip>
          <el-button class="edit-type-add-button" type="danger" v-if="!i.isBase" @click="delCost(i, k)">
            {{ $t("remove") }}
          </el-button>
          <el-button class="edit-type-add-button" type="primary" @click="addDetailCost(k)">
            {{ $t("contract.addCost") }}
          </el-button>
        </p>
        <el-table border class="contract-cost-table" :data="i.data" stripe>
          <template v-for="(item,kindex) in i.trainerCostList">
            <el-table-column :prop="item.prop"
                          :key="'trainerCost'+item.prop"
                          v-if="item.prop!=='action'"
                          show-overflow-tooltip
                          :width="item.width"
                          header-align="center"
                          align="center"
                          :label="item.label">
                <template slot-scope="scope">
                  <div v-if="!scope.row.edit">
                    <span v-if="item.prop==='trainerLevelKey'">{{ filterTrainerLevel(scope.row[item.prop]) }}</span>
                    <span v-else-if="item.prop==='trainerExpenseKey'">{{ filterCostType(scope.row[item.prop]) }}</span>
                    <span v-else-if="item.prop==='grantExpenseKey'">{{ 
                      filterCostGrantType(scope.row[item.prop]) }}</span>
                    <span v-else-if="item.prop==='consumablesLevelKey'">{{ 
                      filterConsumables(scope.row[item.prop]) }}</span>
                    <span v-else-if="item.prop==='certLevelKey'">{{ filterCertLevel(scope.row[item.prop]) }}</span>
                    <span v-else-if="item.prop==='unitKey'">{{ 
                      filterUnit(scope.row[item.prop]) }}</span>
                    <span v-else-if="item.prop==='noTaxAmount'">{{ 
                      scope.row[item.prop].toString().indexOf('.') >=0 ? scope.row[item.prop] :
                      scope.row[item.prop]+ '.00' }}</span>
                    <span v-else class="contract-cost-table-span">{{ scope.row[item.prop] }}</span>
                  </div>
                  <div v-else>
                    <el-input
                      v-if="item.prop==='serial'"
                      v-model="scope.row[item.prop]"
                      maxlength="5"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      @blur="getSeries($event, k, scope.$index)"
                      :placeholder="$t('contract.inputTips')"
                    ></el-input>
                    <el-input
                      class="contract-name-limit"
                      v-if="item.prop==='expenseName'"
                      v-model="scope.row[item.prop]"
                      show-word-limit
                      maxlength="200"
                      :placeholder="$t('contract.inputTips')"
                    ></el-input>
                    <el-input-number v-model="scope.row[item.prop]"
                      :min="0" :max="9999999999999.99" :step="0.01" :precision="2"
                      v-if="item.prop==='noTaxAmount'"></el-input-number>
                    <el-select v-model="scope.row[item.prop]" v-if="item.prop==='trainerLevelKey'">
                      <el-option
                        v-for="(item,index) in trainerLevelList"
                        :key="'trainerLevel'+scope.$index+index"
                        :label="item.name"
                        :value="item.code*1"
                      >
                      </el-option>
                    </el-select>
                    <el-select v-model="scope.row[item.prop]" v-if="item.prop==='unitKey'">
                      <el-option
                        v-for="(item,index) in unitTypeList"
                        :key="'unit'+scope.$index+index"
                        :label="item.name"
                        :value="item.code*1"
                      >
                      </el-option>
                    </el-select>
                    <el-select v-model="scope.row[item.prop]" v-if="item.prop==='trainerExpenseKey'">
                      <el-option
                        v-for="(item,index) in costTypeList"
                        :key="'costType'+scope.$index+index"
                        :label="item.name"
                        :value="item.code*1"
                      >
                      </el-option>
                    </el-select>
                    <el-select v-model="scope.row[item.prop]" v-if="item.prop==='grantExpenseKey'">
                      <el-option
                        v-for="(item,index) in grantTypeList"
                        :key="'grandType'+scope.$index+index"
                        :label="item.name"
                        :value="item.code*1"
                      >
                      </el-option>
                    </el-select>
                    <el-select v-model="scope.row[item.prop]" v-if="item.prop==='consumablesLevelKey'">
                      <el-option
                        v-for="(item,index) in consumablesTypeList"
                        :key="'consumables'+scope.$index+index"
                        :label="item.name"
                        :value="item.code*1"
                      >
                      </el-option>
                    </el-select>
                    <el-select v-model="scope.row[item.prop]" v-if="item.prop==='certLevelKey'">
                      <el-option
                        v-for="(item,index) in certTypeList"
                        :key="'cert'+scope.$index+index"
                        :label="item.name"
                        :value="item.code*1"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </template>
            </el-table-column>
            <el-table-column :prop="item.prop"
                          v-else
                          show-overflow-tooltip
                          header-align="center"
                          key="action"
                          align="center"
                          width="100"
                          fixed="right"
                          :label="$t('handle')">
                <template slot-scope="scope">
                  <span class="contract-cost-table-link" 
                  @click="editCost(k, scope.$index)" v-if="!scope.row.edit">{{ $t("update") }}</span>
                  <span class="contract-cost-table-link" 
                  @click="saveListCost(k, scope.$index, scope.row)" v-else>{{ $t("save") }}</span>
                  <span class="contract-cost-table-link link2" 
                  @click="delListCost(k,scope.$index)">{{ $t("remove") }}</span>
                </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </el-form>
    <section class="contract-edit-buttons clearfix">
      <p class="edit-buttons-info">{{ $t('contract.saveInfo') }}</p>
      <div class="edit-buttons-contain">
        <el-button class="edit-button" type="info" @click="backList('noUpdate')" :disabled="saveLoading">
          {{ $t("cancel") }}
        </el-button>
        <el-button class="edit-button" type="primary" @click="saveContract" :loading="saveLoading">
          {{ $t("cert.confirm") }}
        </el-button>
      </div>
   </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contractData: {
        supplierOrgCode: '',
        contractNo: '',
        supplierCode: '',
        supplierNameCn: '',
        supplierNameEn: '',
        ownOrgId: '',
        endTime: '',
        beginTime: '',
        status: '',
        type: ''
      },
      loading: false,
      saveLoading: false,
      editRule: {
        supplierOrgCode: [
          { required: true, message: this.$t('contract.noInfoSupplierNo'), trigger: 'change' },
        ],
        contractNo: [
          { required: true, message: this.$t('contract.noInfoContractNo'), trigger: 'blur' },
          { pattern: /^[-A-Za-z0-9_]*$/, message: this.$t('contract.titleValid') }
        ],
        supplierCode: [
          { required: true, message: this.$t('contract.noInfoSupplierId'), trigger: 'change' },
        ],
        supplierNameCn: [
          { required: true, message: this.$t('contract.noInfoCompanyName'), trigger: 'change' },
        ],
        supplierNameEn: [
          { required: true, message: this.$t('contract.noInfoCompanyName'), trigger: 'change' },
        ],
        beginTime: [
          { required: true, message: this.$t('contract.noInfoBeginTime'), trigger: 'change' },
        ],
        endTime: [
          { required: true, message: this.$t('contract.noInfoEndTime'), trigger: 'change' },
        ],
        status: [
          { required: true, message: this.$t('contract.noInfoStatus'), trigger: 'change' },
        ],
        ownOrgId: [
          { required: true, message: this.$t('contract.noInfoTeam'), trigger: 'change' },
        ],
        type: [
          { required: true, message: this.$t('contract.noInfoType'), trigger: 'change' },
        ],
      },
      typeList: this.enums['contractType'],
      teamList: this.enums['contractOwnOrg'],
      costList: this.enums['contractExpenseType'],
      statusList: [
        { label: this.$t('res.noActivity'), value: '0' },
        { label: this.$t('res.activity'), value: '1' },
      ],
      trainerCostList: [
        { prop: 'serial', label: this.$t('contract.serial'), width: 160, type: 'number' },
        { prop: 'expenseName', label: this.$t('contract.costName') },
        { prop: 'noTaxAmount', label: this.$t('contract.costMoney'), width: 220 },
        { prop: 'unitKey', label: this.$t('contract.costUnit'), width: 110 },
      ],
      trainerCostListEnd: [
        { prop: 'action', label: this.$t('handle') },
      ],
      options: [],
      isEdit: 1,
      releatedEdit: false,
      isEffect: false,
      id: '',
      contractNo: '',
      costType: '',
      defaultCost: {},
      moduleList: [],
      orginModuleList: [],
      unitTypeList: this.enums['contractExpenseUnit'],
      trainerLevelList: this.enums['contractTrainerLevel'],
      costTypeList: this.enums['contractTrainerExpenseType'],
      grantTypeList: this.enums['contractGrantExpenseType'],
      consumablesTypeList: this.enums['consumablesLevel'],
      certTypeList: this.enums['contractCertLevel'],
      pickerOptions: {
        disabledDate: (time) => {
          if (this.contractData.beginTime) {
            return time.getTime() <= new Date(this.contractData.beginTime).getTime();
          }
        }
      },
      pickerOptions2: {
        disabledDate: (time) => {
          if (this.contractData.endTime) {
            return time.getTime() > new Date(this.contractData.endTime).getTime();
          }
        }
      }
    };
  },
  watch: {
    contractData: {
      handler (){
        if (this.contractData.beginTime && this.contractData.endTime &&
          new Date(this.contractData.beginTime).getTime() >= new Date(this.contractData.endTime).getTime()) {
          this.$message({
            message: this.$t('contract.timeValid'),
            type: 'warning',
          });
          this.contractData.endTime = '';
        }
      },
      deep: true
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        this.contractData.supplierNameCn = '';
        this.contractData.supplierNameEn = '';
        this.contractData.supplierCode = '';
        setTimeout(() => {
          this.loading = false;
          this.$request.get(`/sys/org/selectOrgByNameOrCode?nameOrCode=${query}`).then((res) => {
            if (res) {
              this.options = res;
            }
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    choseSupplier () {
      if (this.contractData.supplierOrgCode) {
        this.options.forEach((item) => {
          if (this.contractData.supplierOrgCode === item.orgCode) {
            this.$set(this.contractData, 'supplierNameCn', item.nameCn);
            this.$set(this.contractData, 'supplierNameEn', item.nameEn);
            this.$set(this.contractData, 'venderNo', item.venderNo);
            this.$set(this.contractData, 'supplierCode', item.orgCode);
          }
        });
      }
    },
    backPage (val) {
      this.tabRemove();
      this.beginTime = '';
      this.endTime = '';
      this.contractData = {};
      this.moduleList = [];
      this.$router.push({
        name: 'rm-contract-contractManage'
      });
      this.$eventHub.$emit('contractManage', val === 'update' ? 'update' : '');
    },
    backList (val) {
      this.$confirm(this.$t('contract.backInfo'), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.backPage(val);
      });
    },
    // 删除当前页面
    tabRemove() {
      const tabName = this.$store.state.contentTabsActiveName;
      if (tabName === 'home') {
        return false;
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName);
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home';
        return false;
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name});
      }
    },
    getSeries (e, bindex, index) {
      const obj = Object.assign(this.moduleList[bindex].data[index], { serial: e.target.value });
      this.$set(this.moduleList[bindex].data, index, obj);
    },
    // 保存
    saveContract () {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const params = {
            contractNo: this.contractData.contractNo,
            supplierCode: this.contractData.supplierCode,
            supplierOrgCode: this.contractData.supplierOrgCode,
            beginTime: this.contractData.beginTime + ' 00:00:00',
            endTime: this.contractData.endTime + ' 23:59:59',
            ownOrgId: this.contractData.ownOrgId,
            type: this.contractData.type,
            status: this.contractData.status
          };
          const nmap = {};
          let flag = false;
          // 培训师费用不可级别相同且类别相同
          const trainerArr = this.moduleList.filter((item) => {
            return item.dictValue === '1';
          });
          const trainerCost = trainerArr.length > 0 ? trainerArr[0].data : [];
          const trainerObj = {};
          trainerCost.forEach((item) => {
            if (trainerObj[item.trainerLevelKey]) {
              trainerObj[item.trainerLevelKey].push(item.trainerExpenseKey);
            } else {
              trainerObj[item.trainerLevelKey] = [item.trainerExpenseKey];
            }
          });
          for(let item in trainerObj) {
            if (trainerObj[item].length !== new Set(trainerObj[item]).size) {
              this.$message({
                message: this.$t('contract.trainerInfo2'),
                type: 'warning',
              });
              return false;
            }
          }
          // 补助费用除其他外不可重复条目
          const otherArr = this.moduleList.filter((item) => {
            return item.dictValue === '2';
          });
          const otherCost = otherArr.length > 0 ? otherArr[0].data : [];
          const otherCostNumArr = new Array(9).fill(0);
          otherCost.forEach((val) => {
            otherCostNumArr[val.grantExpenseKey] += 1;
          });
          for(let i=0; i<otherCostNumArr.length; i++) {
            if (otherCostNumArr[i] > 1  && i!== 7) {
              this.$message({
                message: this.$t('contract.otherCostInfo'),
                type: 'warning',
              });
              return false;
            }
          }
          // 编辑不编辑数据校验
          if (this.isEdit === 1) {
            const arr = [];
            for(let item of this.moduleList) {
              nmap[item.dictValue] = item.data;
              for(let i of item.data) {
                arr.push(i.serial*1)
                const keyArr = Object.keys(i);;
                for(let m of keyArr) {
                  if (!i[m]&&m!=='edit') {
                    flag = true;
                    break;
                  }
                }
              }
            }
            if (arr.length !== new Set(arr).size) {
              this.$message({
                message: this.$t('contract.costLevelIndexInfo'),
                type: 'warning',
              });
              return false;
            }
          } else {
            // 编辑时候
            const mobj = {};
            const data = this.moduleList;
            const arr = [];
            for(let item of data) {
              mobj[item.dictValue] = [[],[]];
              mobj[item.dictValue][0] = item.data;
              for(let i of item.data) {
                arr.push(i.serial*1);
                mobj[item.dictValue][1].push(i.id);
                const keyArr = item.trainerCostList.map((k) => k.prop );
                for(let m of keyArr) {
                  if (m !== 'action' && m !== 'edit' && !i[m] ) {
                    flag = true;
                    break;
                  }
                }
              }
            }
            if (arr.length !== new Set(arr).size) {
              this.$message({
                message: this.$t('contract.costLevelIndexInfo'),
                type: 'warning',
              });
              return false;
            }
            const mobj2 = {};
            for(let item of this.orginModuleList) {
              for(let i of item.data) {
                if (mobj[item.dictValue]==undefined) {
                  mobj2[item.dictValue] = mobj2[item.dictValue] || [[]];
                  Object.assign(i, { delFlag: 1 });
                  mobj2[item.dictValue][0].push(i);
                } else {
                   if(!mobj[item.dictValue][1].includes(i.id)){
                    Object.assign(i, { delFlag: 1 });
                    mobj[item.dictValue][0].push(i);
                  }
                }
              }
            }
            const fobj = { ...mobj, ...mobj2 };
            Object.keys(fobj).forEach((item)=> {
              nmap[item] = fobj[item][0];
            });
          }
          if (flag) {
            this.$message({
              message: this.$t('contract.costNeedValid'),
              type: 'warning',
            });
            return false;
          }
          params.expensesMaps = nmap
          this.moduleList = this.moduleList.map((item) => {
            item.data = item.data.filter((i)=> !i.delFlag);
            return item;
          })
          this.saveLoading = true;
          if (Number(this.isEdit) === 1) {
            this.$request.post('/learning/contract/addContract', params).then((_res, _total, _code, data) => {
              if (data.msg==='success') {
                this.$message({
                  message: this.$t('contract.addSuccess'),
                  type: 'success',
                });
                this.backPage('update');
              }
              this.saveLoading = false;
            }).catch(() => {
              this.saveLoading = false;
            });
          } else {
            params.id = this.id;
            this.$request.post('/learning/contract/updateContract', params).then((_res, _total, _code, data) => {
              if (data.msg === 'success') {
                this.$message({
                  message: this.$t('contract.editSuccess'),
                  type: 'success',
                });
                this.backPage('update');
              }
              this.saveLoading = false;
            }).catch(() => {
              this.saveLoading = false;
            });
          }
        }
      });
    },
    // 获取列名
    getColumn (val) {
      const trainerCostList = JSON.parse(JSON.stringify(this.trainerCostList));
      let arr = [];
      switch (val*1) {
        case 1:
          arr = [{ prop: 'trainerExpenseKey', label: this.$t('contract.costType'), width: 140 }];
          trainerCostList.splice(1, 0,  { 
              prop: 'trainerLevelKey',
              label: this.$t('contract.trainerLevel'),
              width: 110 });
          break;
        case 2:
          arr = [{ prop: 'grantExpenseKey', label: this.$t('contract.costType'), width: 140 }];
          break;
        case 5:
          trainerCostList.splice(1, 0,  { 
            prop: 'consumablesLevelKey',
            label: this.$t('contract.consumablesLevel'), width: 110});
          break;
        case 6:
          trainerCostList.splice(1, 0,  {
            prop: 'certLevelKey',
            label: this.$t('contract.certLevel'), width: 110 });
          break;
        default:
          break;
      }
      return trainerCostList.concat(arr).concat(this.trainerCostListEnd);
    },
    // 获取详情
    getDetail () {
      this.$request.get(`/learning/contract/getContractInfo?contractNo=${this.contractNo}`).then((res) => {
        if (res) {
          const obj = res;
          Object.assign(obj, { 
            type: obj.type.toString(),
            status: obj.status.toString(),
            ownOrgId: obj.ownOrgId.toString()
          });
          this.contractData = obj;
          this.contractData.beginTime = obj.beginTime;
          this.contractData.endTime = obj.endTime;
          this.releatedEdit = obj.inUse;
          this.isEffect = obj.inEffect;
          const constType = this.defaultCost[this.contractData.type] || [];
          const data = JSON.parse(JSON.stringify(this.enums['contractExpenseType']));
          res.expensesMaps = res.expensesMaps || {};
          this.costList = data.map((item) => {
            Object.keys(res.expensesMaps).forEach((i) => {
              if (i.toString() === item.code.toString()) {
                Object.assign(item, { disabled: true });
              }
            });
            constType.forEach((i) => {
              if (item.code.toString() === i.dictValue.toString()) {
                Object.assign(item, { disabled: true });
              }
            });
            return item;
          });
          const arr = [];
          const marr = [];
          Object.keys(res.expensesMaps).forEach((item) => {
            res.expensesMaps[item] = res.expensesMaps[item].map((k) => {
              Object.assign(k, { noTaxAmount: k.noTaxAmountStr });
              return k;
            });
            for (let i of this.costList) {
              if (i.code.toString() === item.toString()) {
                marr.push(i.code);
                arr.push({ 
                  dictName: i.name,
                  dictValue: i.code,
                  data: res.expensesMaps[item],
                  trainerCostList: this.getColumn(item)
                });
                break;
              }
            }
          });
          arr.forEach((item) => {
            constType.forEach((i) => {
              if (item.dictValue.toString() === i.dictValue.toString()) {
                Object.assign(item, { isBase: true });
              }
            });
          });
          for(let item of constType) {
            if (!marr.includes(item.dictValue)) {
              arr.push({
                dictName: item.dictName,
                dictValue: item.dictValue,
                data: [],
                isBase: true,
                trainerCostList: this.getColumn(item.dictValue)
              });
            }
          }
          this.moduleList = JSON.parse(JSON.stringify(arr));
          this.orginModuleList = JSON.parse(JSON.stringify(arr));
          this.calcauteWidth();
        }
      })
    },
    // 获取默认列表
    changeGetCostList () {
      if (this.contractData.type) {
        const constType = this.defaultCost[this.contractData.type] || [];
        this.costType = '';
        const data = JSON.parse(JSON.stringify(this.enums['contractExpenseType']));
        this.costList = data.map((item) => {
          constType.forEach((i) => {
            if (item.code.toString() === i.dictValue.toString()) {
              Object.assign(item, { disabled: true });
            }
          });
          return item;
        });
        this.baseList = constType.map((item)=> {
          return { 
            dictName: item.dictName,
            dictValue: item.dictValue,
            isBase: true,
            data: [],
            trainerCostList: this.getColumn(item.dictValue)
          };
        });
        this.moduleList = [].concat(this.baseList);
      }
    },
    // 增加费用项类别
    addCost () {
      if (this.costType) {
        const obj = { 
          data: []
        };
        this.costList = this.costList.map((item) => {
          if (item.code === this.costType) {
            obj.dictName = item.name;
            obj.dictValue = item.code;
            Object.assign(item, { disabled: true });
          }
          return item;
        });
        obj.trainerCostList = this.getColumn(this.costType);
        this.moduleList.push(obj);
        this.costType = '';
      } else {
        this.$message({
          message: this.$t('contract.costTypeInfo'),
          type: 'warning',
        });
      }
    },
    // 删除费用项
    delCost (val, index) {
      if (!val.isBase) {
        this.$confirm(this.$t('pop.confirmDel'), this.$t('prompt.title'), {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
        }).then(() => {
          this.moduleList.splice(index, 1);
          this.costList = this.costList.map((item) => {
            if (item.code === val.dictValue) {
              Object.assign(item, { disabled: false });
            }
            return item;
          });
        });
      }
    },
    addDetailCost (index) {
      const params = {
        serial: null,
        expenseName: '',
        noTaxAmount: null,
        unitKey: '',
        edit: true
      };
      switch (this.moduleList[index].dictValue*1) {
        case 1:
          params.trainerLevelKey = '';
          params.trainerExpenseKey = '';
          break;
        case 2:
          params.grantExpenseKey = '';
          break;
        case 5:
          params.consumablesLevelKey = '';
          break;
        case 6:
          params.certLevelKey = '';
          break;
        default:
          break;
      }
      this.moduleList[index].data.push(params);
    },
    // 编辑费用
    editCost (bindex, index) {
      this.$set(this.moduleList[bindex].data[index], 'edit', true );
    },
    // 保存每一条费用使其不显示编辑状态
    saveListCost (bindex, index, row) {
      let flag = false
      const keyArr = this.moduleList[bindex].trainerCostList.map((k) => k.prop );
      for(let i of keyArr) {
        if (!row[i] && i!=='edit' && i!=='action') {
          flag = true;
          break;
        }
      }
      if (flag) {
        this.$message({
          message: this.$t('contract.costNeedValid'),
          type: 'warning',
        });
        return false
      }
      // 培训师费用不可级别相同且类别相同
      const trainerCost = this.moduleList[bindex].dictValue === '1' && 
        this.moduleList[bindex].data.length>0 ? this.moduleList[bindex].data : [];
      const obj = {};
      trainerCost.forEach((item) => {
        if (obj[item.trainerLevelKey]) {
          obj[item.trainerLevelKey].push(item.trainerExpenseKey);
        } else {
          obj[item.trainerLevelKey] = [item.trainerExpenseKey];
        }
      });
      for(let item in obj) {
        if (obj[item].length !== new Set(obj[item]).size) {
          this.$message({
            message: this.$t('contract.trainerInfo2'),
            type: 'warning',
          });
          return false;
        }
      }
      // 补助费用除其他外不可重复条目
      const otherCost = this.moduleList[bindex].dictValue === '2' &&
        this.moduleList[bindex].data.length>0 ? this.moduleList[bindex].data : [];
      const otherCostNumArr = new Array(9).fill(0);
      otherCost.forEach((val) => {
        otherCostNumArr[val.grantExpenseKey] += 1;
      });
      for(let i=0; i<otherCostNumArr.length; i++) {
        if (otherCostNumArr[i] > 1 && i!== 7) {
          this.$message({
            message: this.$t('contract.otherCostInfo'),
            type: 'warning',
          });
          return false;
        }
      }
      let arr = [];
      this.moduleList.forEach((val) => {
        arr = arr.concat(val.data.filter((item) => {
          return item.serial == row.serial;
        }));
      });
      if (arr.length > 1) {
        this.$message({
          message: this.$t('contract.costLevelIndexInfo'),
          type: 'warning',
        });
        return false;
      } else {
        this.$set(this.moduleList[bindex].data[index], 'edit', false );
      }
    },
    // 删除小费用明细
    delListCost (bindex, index) {
      this.moduleList[bindex].data.splice(index, 1);
    },
    filterTrainerLevel (val) {
      for(let item of this.trainerLevelList) {
        if (item.code.toString() === val.toString()) {
          return item.name;
        }
      }
    },
    filterCostType (val) {
      for(let item of this.costTypeList) {
        if (item.code.toString() === val.toString()) {
          return item.name;
        }
      }
    },
    filterUnit (val) {
      for(let item of this.unitTypeList) {
        if (item.code.toString() === val.toString()) {
          return item.name;
        }
      }
    },
    filterCertLevel (val) {
      for(let item of this.certTypeList) {
        if (item.code.toString() === val.toString()) {
          return item.name;
        }
      }
    },
    filterConsumables (val) {
      for(let item of this.consumablesTypeList) {
        if (item.code.toString() === val.toString()) {
          return item.name;
        }
      }
    },
    filterCostGrantType (val) {
      for(let item of this.grantTypeList) {
        if (item.code.toString() === val.toString()) {
          return item.name;
        }
      }
    },
    // 获取合同类型关联关系
    getContractCostType () {
      this.$request.post('/learning/contract/getExpenseType').then((res) => {
        if (res) {
          this.defaultCost = res;
          if (this.contractNo) {
            this.getDetail();
          }
        }
      });
    },
    calcauteWidth () {
      let arr = [];
      let index = null;
      for(let i=0; i<this.moduleList.length; i++) {
        if (this.moduleList[i].dictValue === '1') {
          arr = this.moduleList[i].trainerCostList;
          index = i;
          break;
        }
      }
      if (arr.length > 0) {
        const num = (this.$refs.contractContain.offsetWidth - 30 )*0.85 - 800;
        if (num < 250) {
          this.$set(this.moduleList[index].trainerCostList[2], 'width', 250);
        }
      }
    }
  },
  mounted() {
    this.isEdit = this.$route.query.edit;
    this.contractNo = this.$route.query.contractNo || '';
    this.id = this.$route.query.id || '';
    this.releatedEdit = false;
    this.isEffect = false;
    this.getContractCostType();
    this.calcauteWidth();
    window.onresize = () => {
      this.calcauteWidth();
    };
    this.$eventHub.$on("contractManageEdit", () => {
      this.contractData = {};
      this.moduleList = [];
      this.orginModuleList = [];
      this.contractNo = this.$route.query.contractNo || '';
      this.id = this.$route.query.id || '';
      this.releatedEdit = false;
      this.isEffect = false;
      this.getContractCostType();
    });
  },
};
</script>
<style lang="scss" scoped>
 .contract-edit-contain {
   min-height: calc(100% - 120px);
   background-color: #ffffff;
   padding: 15px;
   .contract-edit-title {
     font-size: 16px;
     font-weight: bold;
     &.contract-edit-title2 {
       width: 100%;
       .edit-button {
         margin-left: 20px;
       }
     }
   }
   .contract-edit-form {
     display: flex;
     flex-wrap: wrap;
     .contract-form-li {
       width: 25% !important;
       padding-right: 30px;
       margin-bottom: 20px !important;
     }
     .food-module,.trainer-module {
       width: 100%;
       display: flex;
       flex-wrap: wrap;
       .contract-edit-title-trainer {
         width: 100%;
       }
     }
   }
   .contract-cost-add {
     width: 100%;
     margin-bottom: 20px;
     .contract-cost-add-select {
       width: 25% !important;
       padding-right: 30px;
     }
   }
   .contract-type-module {
     width: 100%;
     margin-bottom: 26px;
    .contract-type-module-title {
      font-size: 16px;
      height: 32px;
      line-height: 32px;
      font-weight: bold;
      width: 85%;
      margin-bottom: 20px;
      .edit-type-add-button {
        float: right;
        margin-left: 20px;
      }
    }
    .contract-cost-table {
      width: 85%;
      tr {
        height: 48px !important;
      }
      td {
        padding: 0 !important;
      }
      .contract-cost-table-link {
        cursor: pointer;
        color: #409eff;
        &:hover {
          opacity: .7;
        }
        &:nth-child(1) {
          margin-right: 12px;
        }
        &.link2 {
          color: #F56C6C;
        }
      }
      .contract-cost-table-span {
        display: block;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
   }
   .contract-edit-buttons {
     margin-top: 10px;
     .edit-buttons-info {
       margin: 0;
       float: left;
       line-height: 34px;
       color: #606266;
     }
     .edit-buttons-contain {
      float: right;
      text-align: right;
      padding-right: 35px;
      .edit-button {
        display: inline-block;
      }
    }
   }
   .contract-type-question {
     color:#409eff;
   }
  .el-input-number{
    line-height: 32px !important;
  }
  .el-button--danger:hover, .el-button--danger:focus {
    background: #f78989 !important;
    border-color: #f78989 !important;
  }
 } 
</style>
<style lang="scss">
.contract-cost-table {
  tr {
    height: 48px !important;
  }
  td {
    padding: 0 !important;
  }
  .contract-name-limit {
    .el-input__inner {
      padding-right: 58px !important;
    }
  }
}
</style>